import React, { useState } from 'react'
import { pascalCase } from 'change-case'
import { connect } from 'react-redux'
import { 
  Field, 
  getFormValues, 
  SubmissionError 
} from 'redux-form'
import { 
  Button, 
  Confirm, 
} from  'semantic-ui-react'

import { 
  StdCard ,
  CommentRow
} from 'components'
import { 
  approveActionContract 
} from 'ducks/contract'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { Cont } from './styled'

const Approve = (props) => {
  const { 
    data={}, 
    handleSubmit, 
    approveActionContract, 
    valueForm,
    history 
  } = props
  const approverAction = data.actions||['Approve', 'Revise', 'Reject']

  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  function submitValidate(action){
    setSubmitActionName(action)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
    .then(() => {
      if(['reject','revise','cancel'].indexOf(action.toLowerCase())>=0) {
        if((valueForm.actionComment&&valueForm.actionComment.trim().length === 0)||!valueForm.actionComment) {
          throw new SubmissionError({ actionComment: 'Required!'})
        }
      }
      setShowConfirm(true)
    })
  }

  function submitAction() {
    setShowConfirm(false)
    approveActionContract({
      docId: valueForm.id,
      sn: valueForm.sn,
      action: submitActionName,
      comment: valueForm.actionComment,
      commentAttachments: valueForm.commentAttachments
    }, history)
  }

  return (
    approverAction.length === 0 ? null :
    <React.Fragment>
      <StdCard title={`Action ${valueForm&&valueForm.status==5?'':'for Approval'}`} highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
        <Cont>
          <div style={{ display:'flex', flexDirection: 'column' }}>
            <Field 
              name='actionComment' 
              label='Your Comment' 
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} /> 
            <Field
              name='commentAttachments'
              label='Attachments'
              type={type.file}
              component={FieldInput}
              containerStyle={{ marginRight: 0 }}
            />
            <div style={{ marginTop: '1rem' }}>
              {
                valueForm&&valueForm.actions&&valueForm.actions.map((item) => 
                  <Button 
                    key={item}
                    type='button' 
                    color={`${['reject','cancel'].indexOf(item.toLowerCase())>=0?'red':item.toLowerCase()==='revise'?'orange':'green'}`}
                    onClick={
                      handleSubmit(()=>submitValidate(item))
                    }
                  >
                    {pascalCase(item)}
                  </Button>
                )
              }
            </div>
          </div>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />  
        </Cont>
      </StdCard>
      <div style={{height:'1rem'}}/>
      <StdCard title='Last Comment' style={{ marginTop: '1rem' }} enableCollapse>
        <Cont>
          {valueForm&&valueForm.contractComments&&valueForm.contractComments[0]&&
            <CommentRow 
            data={valueForm&&valueForm.contractComments&&valueForm.contractComments[0]} 
            files={valueForm&&valueForm.attachments.filter(x=>x.commentId===valueForm.contractComments[0].id)} />}
        </Cont>
      </StdCard>
    </React.Fragment>
  )

}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formContract')(state),
  })
}

const mapDispatchToProps = {
  approveActionContract
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)
